import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'https://ncai-chat.bill-burkey.workers.dev';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  register: (data: {
    email: string;
    password: string;
    fullName: string;
    organizationName: string;
  }) => api.post('/api/auth/register', data),

  login: (data: { email: string; password: string }) =>
    api.post('/api/auth/login', data),

  logout: () => api.post('/api/auth/logout'),

  me: () => api.get('/api/auth/me'),
};

export const widgetsApi = {
  list: (organizationId: string) =>
    api.get(`/api/widgets?organizationId=${organizationId}`),

  get: (id: string) => api.get(`/api/widgets/${id}`),

  create: (data: any) => api.post('/api/widgets', data),

  update: (id: string, data: any) => api.patch(`/api/widgets/${id}`, data),

  delete: (id: string) => api.delete(`/api/widgets/${id}`),

  getEmbedCode: (id: string) => api.get(`/api/widgets/${id}/embed`),
};

export const conversationsApi = {
  list: (params: { widgetId?: string; organizationId?: string; status?: string; page?: number }) =>
    api.get('/api/conversations', { params }),

  get: (id: string) => api.get(`/api/conversations/${id}`),

  update: (id: string, data: any) => api.patch(`/api/conversations/${id}`, data),

  delete: (id: string) => api.delete(`/api/conversations/${id}`),
};

export const analyticsApi = {
  getWidgetAnalytics: (widgetId: string, params?: { startDate?: number; endDate?: number }) =>
    api.get(`/api/analytics/widgets/${widgetId}`, { params }),

  getOrganizationAnalytics: (orgId: string, params?: { startDate?: number; endDate?: number }) =>
    api.get(`/api/analytics/organizations/${orgId}`, { params }),
};

export default api;
